import { sendToCurrentOnboardingSteps } from "@/actions/pages/admins/dashboard/clients/common";
import { ADMIN_SIDEBAR_OPTIONS } from "@/constants/components/sidebar";
import { Button, ButtonStyle, PopupStyle, Congrats, Form, PageStyle, Formik, FormikControl, goToNextPage,
         InputError, INITIAL_VALUES, motion, nextStep, PAGE_ANIMATION_OPTIONS, REDIRECT,
         useState, useQueryClient, useRouter, useTranslation, VALIDATION_SCHEMA, useEffect, DataFromUrl, ErrorPages, AdminClientNewAction, Checkbox, AutocompleteError} from "@/imports-files/pages/admins/dashboard/clients/new";

import Image from 'next/image';
import ArrowLeft from 'public/icons/arrowleft.svg';
import ColorPicker from '@/components/color-picker';
import {BrandGuide} from '@/components/brand-guide-modal';
import { useRef } from "react";
import PlaceAutoComplete from 'react-places-autocomplete';


function ClientForm(props)
{

  const router                                     =   useRouter();
  const { t, i18n }                                =   useTranslation();
  const errorPages                                 =    new ErrorPages()
  const [buttonPopup, setButtonPopup]              =   useState(false);
  const [clientId, setClientId]                    =   useState(0);
  const queryClient                                =   useQueryClient();
  const [apiError, setApiError]                    =   useState({status: 200});
  const [brandModal, setBrandModal]                =   useState(false);
  const [selectedBrandLogo,setSelectedBrandLogo]   =   useState();
  const [selectedEmailLogo,setSelectedEmailLogo]   =   useState();
  const [selectedSidebarLogo, setSelectedSidebarLogo]   =   useState();
  const [flagForRender,setFlagForRender]           =   useState();
  const formRef                                    =   useRef(null);
  const hiddenBrandLogoInputRef = useRef();
   const hiddenEmailLogoInputRef = useRef();
   const hiddenSidebarLogoInputRef = useRef();
  const adminClientNewAction                       =   new AdminClientNewAction(setApiError, formRef, setFlagForRender, selectedBrandLogo, selectedEmailLogo, selectedSidebarLogo);
  const initialValues                              =   adminClientNewAction.setInitialProps(props.initialValues) || INITIAL_VALUES
  if(!initialValues.client.location_attributes){
    initialValues.client.location_attributes = {
        full_address: '',
        place_id: ''
      }
  }

  useEffect(() => {
                      var url_array    =   window.location.pathname.split('/');
                      var step_name    =   url_array[url_array.length - 1];
                      var clientId     =   new DataFromUrl().getClientId();
                      sendToCurrentOnboardingSteps( step_name, clientId, ADMIN_SIDEBAR_OPTIONS, queryClient, props.setPageName, 'clients');
                  })
function shouldFetchSuggestions(formik) {
          return formik.values.client.location_attributes?.full_address?.length >= 3
}
  return (
    <>

      <div className={`DashboardPageContent`}>
        <motion.div initial="pageInitial"  animate="pageAnimate"  exit="pageExit"  variants={PAGE_ANIMATION_OPTIONS}  transition={{ delay: 0.2}}>
        <div className={`Page ${PageStyle.ClientCompany}`}>

        <div className={ PageStyle.ClientCompany__Container}>
          <div className={PageStyle.ClientCompany__BackSection}>
            <span onClick={()=>{
                                  var link = REDIRECT.admins.dashboard.clients.client;
                                  router.push(link)
                                  // goToNextPage('clients', props.setPageName, queryClient, REDIRECT.admins.dashboard.clients.client)
                                }}>

            <ArrowLeft />
          <span className={`ml15`}>{t('common:texts:back_to_company')}</span>

            </span>
          </div>

          <div className={PageStyle.ClientCompany__FormSection}>
            <h1 className={PageStyle.ClientCompany__Heading}>
              {t('common:texts:new_client')}
              <span className={PageStyle.ClientCompany__Company}> {t('common:texts:company')} </span>
            </h1>

            <h4 className={PageStyle.ClientCompany__Subheading}>
              {t('page:admins:client:company:texts:subheading')}
            </h4>

            <Formik
              initialValues     = {initialValues}
              validationSchema  = {VALIDATION_SCHEMA}
              initialErrors     = {{}}
              innerRef          = {formRef}
              onSubmit={ async (values, actions) =>  {
                  const errors = await adminClientNewAction.handleFormSubmit(values, router, t, setButtonPopup, setClientId, setApiError, selectedEmailLogo, selectedBrandLogo, selectedSidebarLogo) ;
                  actions.setErrors(errors)
              }
            }
            >
              {(formik) => (
                <Form className={PageStyle.Form}>
                        <div className={PageStyle.Form__Table}>

                     <div className={PageStyle.Form__TableRow}>
                          <div className={PageStyle.Form__TableCol}>
                              <label className={PageStyle.Form__Label}> {t('common:texts:name')} *</label>
                              <FormikControl
                                className   =   {PageStyle.Form__Input}
                                control     =   "input"
                                errorClass  =   {PageStyle.Form__Error}
                                formik      =   {formik}
                                name        =   "client.name"
                                placeholder =   "e.g Charlie Recruit"
                                style       =   {InputError(formik, "client.name")}
                                type        =   "text"
                              />
                          </div>

                          <div className={PageStyle.Form__TableCol}>
                            <label className={PageStyle.Form__Label}> {t('common:texts:website')} {/* <span className={`optionalLabel`}>{t('page:clients:job-form:texts:optional')}</span> */}</label>
                            <FormikControl
                              control     =   "input"
                              className   =   {PageStyle.Form__Input}
                              errorClass  =   {PageStyle.Form__Error}
                              formik      =   {formik}
                              name        =   "client.website"
                              placeholder =   "www.companywebsite.com"
                              style       =   {InputError(formik, "client.website")}
                              type        =   "text"
                            />
                          </div>
                       </div>
                        <div className={PageStyle.Form__TableRow}>
                          <div className={PageStyle.Form__Label}>
                            <label className={PageStyle.Form__Label}> {t('common:texts:account_owner')} *</label>
                            <FormikControl
                              className   = {PageStyle.Form__Input}
                              control     = "input"
                              formik      =  {formik}
                              errorClass  = {PageStyle.Form__Error}
                              name        = "client.super_account_owner_attributes.user_attributes.name"
                              placeholder = "Name"
                              style       = {InputError(formik, "client.super_account_owner_attributes.user_attributes.name")}
                              type        = "text"
                              />
                          </div>

                          <div className={PageStyle.Form__Label}>
                            <label className={PageStyle.Form__Label}>{t('common:texts:contact_number')} *</label>
                            <FormikControl
                              className       =   {PageStyle.Form__Input}
                              control         =   "input"
                              errorClass      =   {PageStyle.Form__Error}
                              formik          =   {formik}
                              infoPlaceholder =   {t('page:admins:client:company:texts:account_info')}
                              name            =   "client.super_account_owner_attributes.user_attributes.contact_no"
                              placeholder     =   "+44 1234 567890"
                              style           =   {InputError(formik, "client.super_account_owner_attributes.user_attributes.contact_no")}
                              type            =   "text"
                            />
                          </div>
                    </div>

                    <div className={`${PageStyle.Form__TableRow}`}>

                      <div className={PageStyle.Form__TableCol}>
                        <label className={PageStyle.Form__Label}> {t('common:texts:email')} *</label>
                        <FormikControl
                          className         =  {PageStyle.Form__Input}
                          control           =  "input"
                          errorClass        =  {PageStyle.Form__Error}
                          formik            =   {formik}
                          infoPlaceholder   =  {t('page:admins:client:company:texts:email_info')}
                          name              =  "client.super_account_owner_attributes.user_attributes.email"
                          placeholder       =  "e.g Jon@smith.com"
                          type              =  "text"
                          autoComplete      =  "password"
                          style             =  {InputError(formik, "client.super_account_owner_attributes.user_attributes.email")}

                        />
                      </div>

                      <div className={`${PageStyle.Form__TableCol}`}>
                        <label className={PageStyle.Form__Label}> {t('common:texts:location')} *{/* <span className={`optionalLabel`}>{t('page:clients:job-form:texts:optional')}</span> */} </label>
                        
                        <PlaceAutoComplete
        value={formik.values.client.location_attributes?.full_address || ''}
        onChange={async (value) => { if(formik.status?.client?.location_attributes?.full_address)
          {
           delete formik.status.client.location_attributes.full_address;
           delete formik.status.client.location_attributes;
           await formik.setStatus(formik.status);
          }
          await formik.setFieldValue('client.location_attributes.full_address', value)
          await formik.setFieldValue('client.location_attributes.place_id', "")
         }}
        //onChange={(address) => formik.setFieldValue('client.location_attributes.full_address', address)}
        onSelect={(address, placeId) =>{
          formik.setFieldValue('client.location_attributes.full_address', address)
          formik.setFieldValue('client.location_attributes.place_id', placeId)
        }
          
        }
        shouldFetchSuggestions={shouldFetchSuggestions(formik)}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div className="autocomplete-root">
            <input
              {...getInputProps({
                name: 'client.location_attributes.full_address',
                className: PageStyle.Form__Input398,
                style: InputError(formik, 'client.location_attributes.full_address'),
              })}
            />
            <div className="autocomplete-dropdown-container">
              {loading && <div>Loading...</div>}
              {suggestions.map((suggestion, index) => {
                const className = suggestion.active
                  ? 'suggestion-item--active'
                  : 'suggestion-item';
                const style = suggestion.active
                  ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                  : { backgroundColor: '#ffffff', cursor: 'pointer' };
                return (
                  <div
                    key={index}
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style,
                    })}
                  >
                    {suggestion.description}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlaceAutoComplete>
      <AutocompleteError
                            name="client.location_attributes.full_address"
                            errorClass={PageStyle.Form__Error}
                            formik={formik}
                            style={InputError(formik, "client.location_attributes.full_address")}
                            custom_error_90={'custom_error_90'}
                          />


                        {/* <FormikControl
                          control         =   "input"
                          className       =   {PageStyle.Form__Input}
                          errorClass      =   {PageStyle.Form__Error}
                          formik          =   {formik}
                          name            =   "client.location_attributes.full_address"
                          placeholder     =   "Enter complete address or city and country."
                          style           =   {InputError(formik, "client.location_attributes.full_address")}
                          type            =   "text"
                        /> */}
                      </div>
                  </div>

                  <div className={`borderbottom ${PageStyle.Form__TableRow} mt30`}>
                    <div className={PageStyle.Form__TableCol}>
                      <div className={PageStyle.DpFlx}>
                        <label className={`${PageStyle.Form__AdminCheckLabel} CursorPointer`}>
                          <Checkbox
                            name="client.ai_access"
                            onChange={(event) => formik.setFieldValue('client.ai_access', event.target.checked)}
                            inputProps={{ "aria-label": "Al Access" }}
                            checked={formik.values.client.ai_access}
                            id={'client_ai_access'}
                          />
                          <span className={`${PageStyle.Form__AdminCheckMargin}`}>{t('page:admins:client:company:texts:ai_access_allowed')}</span>
                        </label>
                      </div>
                    </div>
                  </div>


                  {!process.env.NEXT_PUBLIC_CHARLIE_HR && <>
                  <h4 className={`mt30 ${PageStyle.CompanyProfile__Subheading}`}>
                                    Branding Elements  <span className={PageStyle.CompanyProfile__BrandingGuide} onClick={()=> setBrandModal(true)}>HELP GUIDE</span>
                              </h4>

                              <div className={`Dpflex`}>
                                  <div className={PageStyle.Form__TableCol}>
                                    <span className={PageStyle.Form__Label}> Upload Thumbnail Logo</span>
                                      <div className={`Dpflex Dpflexstart w-100 mb30 checkbox_span_padding`}>
                                        <Checkbox
                                          checked={formik.values.client.client_branding_attributes.sidebar_logo_branding}
                                          name={'client.client_branding_attributes.sidebar_logo_branding'}
                                          onChange={(event) => formik.setFieldValue('client.client_branding_attributes.sidebar_logo_branding', event.target.checked)}
                                        />{" "}
                                        <span className={`mb0 ${PageStyle.Form__CheckLabel} fs14`}>
                                          Use for account branding{" "}
                                        </span>
                                      </div>

                                    <div className={`${PageStyle.CompanyProfile__DropBoxContainer} ${PageStyle.Height80}`}>
                                    {/* PREVIEW IMAGE */}
                                       <div className={`logo_preview_container company_logo_preview_container ${adminClientNewAction.setPreviewImageClass(formik.values.client.client_branding_attributes?.sidebar_logo_url)}`}>
                                         <img id='sidebar_logo_preview' alt="sidebar_logo_preview" className={adminClientNewAction.setPreviewImageClass(formik.values.client.client_branding_attributes?.sidebar_logo_url)} src={formik.values.client.client_branding_attributes?.sidebar_logo_url}/>
                                       </div>
                                    {/* PREVIEW IMAGE */}

                                    <div className={`${adminClientNewAction.setDragDropClass(formik.values.client.client_branding_attributes?.sidebar_logo_url)} ${PageStyle.DropContainer}`} id='sidebar_logo_preview_drag_drop'>
                                        <div className={PageStyle.CompanyProfile__Inner}
                                          onDragOver={(event)=>{adminClientNewAction.dragOver(event)}}
                                          onDragEnter={(event)=>{adminClientNewAction.dragEnter(event)}}
                                          onDragLeave={(event)=>{adminClientNewAction.dragLeave(event)}}
                                          onDrop={(event) => {
                                            event.preventDefault();
                                            if (props.isDisabled)
                                              return false;
                                            else
                                              adminClientNewAction.selectFile(event.dataTransfer.files[0], setSelectedSidebarLogo, 'sidebar_logo')
                                          }} >
                                            <div className={PageStyle.CompanyProfile__Message}>
                                              <div className={PageStyle.CompanyProfile__UploadIcon}></div>
                                              <div className={PageStyle.CompanyProfile__MessageContent}>
                                                  <h4>Drag & drop your file</h4>
                                                  <span>Dimensions - 100px*100px</span>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <div className={` BrowseFile ${PageStyle.CompanyProfile__Browse} ${PageStyle.Browse__ButtonFlexEnd}`}>

                                          <Button onClick={()=>{adminClientNewAction.openHiddenFileUploader(hiddenSidebarLogoInputRef)}} buttonstyle={ButtonStyle.primarybtn} disabled={props.isDisabled}>
                                            Browse to Upload

                                          </Button>

                                          <div className={PageStyle.CompanyProfile__MessageContent}>
                                                  <span>Max file size is 200KB</span>
                                                </div>

                                    </div>

                                        <input
                                            type          =   "file"
                                            accept        =   {".png"}
                                            ref           =    {hiddenSidebarLogoInputRef}
                                            id            =   "BrandLogoInput"
                                            name          =   "client.client_branding_attributes.sidebar_logo"
                                            className     =   {PageStyle.Form__Input398}
                                            formik        =   {formik}
                                            errorClass    =   {PageStyle.Form__Error}
                                            style         =   { InputError( formik, "client.client_branding_attributes.sidebar_logo" ) }
                                            onChange={(event) => {adminClientNewAction.selectFile(event.target.files[0], setSelectedSidebarLogo, 'sidebar_logo') }}
                                        />
                                        </div>
                                         <label className={PageStyle.ErrorLabel}>{formik.status?.client?.client_branding_attributes?.sidebar_logo || ''}</label>
                                    </div>
                              </div>

                              <div className={`Dpflex mt30`}>
                                  <div className={PageStyle.Form__TableCol}>
                                    <span className={PageStyle.Form__Label}> Upload Brand Logo</span>
                                      <div className={`Dpflex Dpflexstart w-100 mb30 checkbox_span_padding`}>
                                        <Checkbox
                                          checked={formik.values.client.client_branding_attributes.logo_branding}
                                          name={'client.client_branding_attributes.logo_branding'}
                                          onChange={(event) => formik.setFieldValue('client.client_branding_attributes.logo_branding', event.target.checked)}
                                        />{" "}
                                        <span className={`mb0 ${PageStyle.Form__CheckLabel} fs14`}>
                                          Use for account branding{" "}
                                        </span>
                                      </div>

                                    <div className={`${PageStyle.CompanyProfile__DropBoxContainer} ${PageStyle.Height80}`}>
                                    {/* PREVIEW IMAGE */}
                                       <div className={`logo_preview_container company_logo_preview_container ${adminClientNewAction.setPreviewImageClass(formik.values.client.client_branding_attributes?.logo_url)}`}>
                                         <img id='brand_logo_preview' alt="brand_logo_preview" className={adminClientNewAction.setPreviewImageClass(formik.values.client.client_branding_attributes?.logo_url)} src={formik.values.client.client_branding_attributes?.logo_url}/>
                                       </div>
                                    {/* PREVIEW IMAGE */}

                                    <div className={`${adminClientNewAction.setDragDropClass(formik.values.client.client_branding_attributes?.logo_url)} ${PageStyle.DropContainer}`} id='brand_logo_preview_drag_drop'>
                                        <div className={PageStyle.CompanyProfile__Inner}
                                          onDragOver={(event)=>{adminClientNewAction.dragOver(event)}}
                                          onDragEnter={(event)=>{adminClientNewAction.dragEnter(event)}}
                                          onDragLeave={(event)=>{adminClientNewAction.dragLeave(event)}}
                                          onDrop={(event) => {
                                            event.preventDefault();
                                            if (props.isDisabled)
                                              return false;
                                            else
                                              adminClientNewAction.selectFile(event.dataTransfer.files[0], setSelectedBrandLogo, 'brand_logo')
                                          }} >
                                            <div className={PageStyle.CompanyProfile__Message}>
                                              <div className={PageStyle.CompanyProfile__UploadIcon}></div>
                                              <div className={PageStyle.CompanyProfile__MessageContent}>
                                                  <h4>Drag & drop your file</h4>
                                                  <span>Dimensions - 184px*50px</span>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <div className={` BrowseFile ${PageStyle.CompanyProfile__Browse} ${PageStyle.Browse__ButtonFlexEnd}`}>

                                          <Button onClick={()=>{adminClientNewAction.openHiddenFileUploader(hiddenBrandLogoInputRef)}} buttonstyle={ButtonStyle.primarybtn} disabled={props.isDisabled}>
                                            Browse to Upload

                                          </Button>

                                          <div className={PageStyle.CompanyProfile__MessageContent}>
                                                  <span>Max file size is 200KB</span>
                                                </div>

                                    </div>

                                        <input
                                            type          =   "file"
                                            accept        =   {".png"}
                                            ref           =    {hiddenBrandLogoInputRef}
                                            id            =   "BrandLogoInput"
                                            name          =   "client.client_branding_attributes.logo"
                                            className     =   {PageStyle.Form__Input398}
                                            formik        =   {formik}
                                            errorClass    =   {PageStyle.Form__Error}
                                            style         =   { InputError( formik, "client.client_branding_attributes.logo" ) }
                                            onChange={(event) => {adminClientNewAction.selectFile(event.target.files[0], setSelectedBrandLogo, 'brand_logo') }}
                                        />
                                        </div>
                                         <label className={PageStyle.ErrorLabel}>{formik.status?.client?.client_branding_attributes?.logo || ''}</label>
                                    </div>
                              </div>

                              <div className={`Dpflex mt30`}>
                                  <div className={PageStyle.Form__TableCol}>
                                    <span className={`${PageStyle.Form__Label}`}> Upload Email Logo</span>

                                    <div className={`${PageStyle.CompanyProfile__DropBoxContainer} ${PageStyle.Height80} mt30`}>
                                     {/* PREVIEW IMAGE */}
                                        <div className={`logo_preview_container company_logo_preview_container ${adminClientNewAction.setPreviewImageClass(formik.values.client.client_branding_attributes?.email_logo_url)}`}>
                                          <img id='email_logo_preview' alt="email_logo_preview" className={adminClientNewAction.setPreviewImageClass(formik.values.client.client_branding_attributes?.email_logo_url) } src={formik.values.client.client_branding_attributes?.email_logo_url}/>
                                        </div>
                                    {/* PREVIEW IMAGE */}
                                    <div className={`${adminClientNewAction.setDragDropClass(formik.values.client.client_branding_attributes?.email_logo_url)} ${PageStyle.DropContainer}`} id='email_logo_preview_drag_drop'>
                                        <div className={PageStyle.CompanyProfile__Inner}
                                          onDragOver={(event)=>{adminClientNewAction.dragOver(event)}}
                                          onDragEnter={(event)=>{adminClientNewAction.dragEnter(event)}}
                                          onDragLeave={(event)=>{adminClientNewAction.dragLeave(event)}}
                                          onDrop={(event) => {
                                            event.preventDefault();
                                            if (props.isDisabled)
                                              return false;
                                            else
                                              adminClientNewAction.selectFile(event.dataTransfer.files[0], setSelectedEmailLogo, 'email_logo')
                                          }} >
                                            <div className={PageStyle.CompanyProfile__Message}>
                                              <div className={PageStyle.CompanyProfile__UploadIcon}></div>
                                              <div className={PageStyle.CompanyProfile__MessageContent}>
                                                  <h4>Drag & drop your file</h4>
                                                  <span>Dimensions - 365px*120px</span>
                                                </div>
                                            </div>

                                        </div>
                                       </div>

                                       <div className={` BrowseFile ${PageStyle.CompanyProfile__Browse} ${PageStyle.Browse__ButtonFlexEnd}`}>

                                          <Button onClick={()=>{adminClientNewAction.openHiddenFileUploader(hiddenEmailLogoInputRef)}} buttonstyle={ButtonStyle.primarybtn} disabled={props.isDisabled}>
                                            Browse to Upload

                                          </Button>

                                          <div className={PageStyle.CompanyProfile__MessageContent}>
                                                  <span>Max file size is 100KB</span>
                                                </div>

                                       </div>

                                       <input
                                            type          =   "file"
                                            accept        =   {".png"}
                                            id            =   "BrandEmailLogoInput"
                                            name          =   "client.client_branding_attributes.email_logo"
                                            ref           =    {hiddenEmailLogoInputRef}
                                            className     =   {PageStyle.Form__Input398}
                                            formik        =   {formik}
                                            errorClass    =   {PageStyle.Form__Error}
                                            style         =   {InputError( formik, "client.client_branding_attributes.email_logo" )}
                                            onChange      =   {(event) => {adminClientNewAction.selectFile(event.target.files[0], setSelectedEmailLogo, 'email_logo') }}
                                          />
                                    </div>
                                     <label className={PageStyle.ErrorLabel}>{formik.status?.client?.client_branding_attributes?.email_logo || ''}</label>
                                    </div>
                              </div>

                              <div className={`${PageStyle.Form__TableRow}`}>
                                  <div className={PageStyle.Form__TableCol}>
                                     <span className={PageStyle.Form__Label}>Brand Color</span>
                                      <div className={PageStyle.Form__Input398}>
                                        <ColorPicker color={props.color} formik={formik} fieldName={'client.client_branding_attributes.primary_color_hex'}/>
                                      </div>
                                  </div>
                              </div>
                              </>}

                {/* <h4 className={`mt30 ${PageStyle.ClientCompany__Subheading}`}> */}
                {/*   Daxtra Details */}
                {/* </h4> */}

{/*                 <div className={PageStyle.Form__TableRow}> */}
{/*                     <div className={PageStyle.Form__TableCol}> */}
{/*                     <label className={PageStyle.Form__Label}> Database Name *</label> */}
{/*                     <FormikControl */}
{/*                       control         =   "input" */}
{/*                       className       =   {`cursornone ${PageStyle.Form__Input}`} */}
{/*                       errorClass      =   {PageStyle.Form__Error} */}
{/*                       formik          =   {formik} */}
{/*                       name            =   "client.daxtra_db_name" */}
{/*                       placeholder     =   "Database" */}
{/*                       style           =   {InputError(formik, "client.daxtra_db_name")} */}
{/*                       type            =   "text" */}
{/*                       disabled        =   {process.env.NEXT_PUBLIC_CHARLIE_HR} */}
{/*                     /> */}
{/*                   </div> */}
{/*  */}
{/*                   <div className={PageStyle.Form__TableCol}> */}
{/*                     <label className={PageStyle.Form__Label}> Username *</label> */}
{/*                     <FormikControl */}
{/*                       control         =   "input" */}
{/*                       className       =   {`cursornone ${PageStyle.Form__Input}`} */}
{/*                       errorClass      =   {PageStyle.Form__Error} */}
{/*                       formik          =   {formik} */}
{/*                       name            =   "client.daxtra_db_username" */}
{/*                       placeholder     =   "Username" */}
{/*                       style           =   {InputError(formik, "client.daxtra_db_username")} */}
{/*                       type            =   "text" */}
{/*                       disabled        =   {process.env.NEXT_PUBLIC_CHARLIE_HR} */}
{/*                     /> */}
{/*                   </div> */}
{/*  */}
{/*               </div> */}
                 {/* <div className={PageStyle.Form__TableRow}> */}
                 {/*    <div className={PageStyle.Form__TableCol}> */}
                 {/*      <label className={PageStyle.Form__Label}> Password *</label> */}
                 {/*      <FormikControl */}
                 {/*        control         =   "input" */}
                 {/*        className       =   {`cursornone ${PageStyle.Form__Input}`} */}
                 {/*        errorClass      =   {PageStyle.Form__Error} */}
                 {/*        formik          =   {formik} */}
                 {/*        name            =   "client.daxtra_db_password" */}
                 {/*        placeholder     =   "Password" */}
                 {/*        style           =   {InputError(formik, "client.daxtra_db_password")} */}
                 {/*        type            =   "text" */}
                 {/*        disabled        =   {process.env.NEXT_PUBLIC_CHARLIE_HR} */}
                 {/*      /> */}
                 {/*    </div> */}
                 {/*  </div> */}
                  <div className={`height30`}></div>

                  <div className={PageStyle.ClientCompany__SubmitSection}>
                      <Button buttonstyle={ButtonStyle.primarybtn} type="submit">{t('common:texts:next_step')}</Button>
                  </div>
</div>
                </Form>
              )}
            </Formik>
          </div>
        </div>

        </div>
        </motion.div>
      </div>

      {brandModal && <BrandGuide setBrandModal={setBrandModal} ></BrandGuide>}

      {/* --------------------------- CONGRATULATION MODAL ---------------------------  */}
      <Congrats trigger={buttonPopup}>
        <div className={PopupStyle.Modalpopup__Content}>
              <h1>{t('common:texts:congratulations')}</h1>
              <span>{t('page:admins:client:congratulations:texts:subheading')}</span>

              <div className={PopupStyle.Modalpopup__btn}>
                <Button buttonstyle={`${ButtonStyle.primarybtn} ${PopupStyle.mar}`} onClick={()=>{
                                                                                                    var link = REDIRECT.admins.dashboard.clients.client;
                                                                                                    router.push(link)
                                                                                                  // goToNextPage('clients', props.setPageName, queryClient, REDIRECT.admins.dashboard.clients.client)}} >
                                                                                                }} >
                    {t('page:admins:client:congratulations:texts:button_all_client')}
                </Button>

                <span>&nbsp;</span>

                {/* <Button buttonstyle={`${ButtonStyle.secondarybtn} ${PopupStyle.mar}`}
                onClick={() => { router.push( REDIRECT.admins.dashboard.clients.users.replace('$client_id', clientId) )}}
                >
                  {t('page:admins:client:congratulations:texts:continue_setup')}
                </Button> */}

                {/* TODO Need to change */}
                <Button buttonstyle={`${ButtonStyle.secondarybtn} ${PopupStyle.mar}`}
                onClick={() =>  {
                                  var link = REDIRECT.admins.dashboard.clients.users.replace('$client_id', clientId);
                                  router.push(link)
                                  //  nextStep( 'add-users', props.setPageName, setButtonPopup, queryClient, REDIRECT.admins.dashboard.clients.users.replace('$client_id', clientId))}
                                }}
                >
                  {t('page:admins:client:congratulations:texts:continue_setup')}
                </Button>

              </div>
        </div>
      </Congrats>
      {/* --------------------------- CONGRATULATION MODAL ---------------------------  */}

    </>
  );
}

export default ClientForm;
